module.exports = __webpack_public_path__ + "static/media/22ESCWA6.f845549c.jpg";